export default __webpack_public_path__ + "static/media/copy.bb0633f8.svg";